import { render, staticRenderFns } from "./VisitEditView.vue?vue&type=template&id=1b344d4c&scoped=true"
import script from "./VisitEditView.vue?vue&type=script&lang=ts"
export * from "./VisitEditView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b344d4c",
  null
  
)

export default component.exports